import { c as _c } from "react/compiler-runtime";
import type { SameTenantDupe } from '@onefootprint/request-types/dashboard';
import { CodeInline, Tag } from '@onefootprint/ui';
import StatusBadge from '@/components/status-badge';
import getTruncatedName from '@/utils/get-truncated-name';
import useDupeKindLabels from '../../hooks/use-dupe-kind-labels';
export type RowProps = {
  duplicateDataItem: SameTenantDupe;
};
const Row = t0 => {
  const $ = _c(25);
  const {
    duplicateDataItem
  } = t0;
  const {
    dupeKinds,
    fpId,
    status,
    startTimestamp,
    data
  } = duplicateDataItem;
  const dupeKindToTranslation = useDupeKindLabels();
  let t1;
  if ($[0] !== data) {
    t1 = getTruncatedName(data);
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <td><div className="text-body-2 text-primary">{t1}</div></td>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== fpId) {
    t3 = <td><CodeInline>{fpId}</CodeInline></td>;
    $[4] = fpId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dupeKindToTranslation || $[7] !== dupeKinds) {
    let t5;
    if ($[9] !== dupeKindToTranslation) {
      t5 = kind => <Tag key={kind}>{dupeKindToTranslation[kind]}</Tag>;
      $[9] = dupeKindToTranslation;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = dupeKinds.map(t5);
    $[6] = dupeKindToTranslation;
    $[7] = dupeKinds;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <td><div className="flex gap-1 flex-wrap py-3">{t4}</div></td>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== status) {
    t6 = <td aria-label="status badge"><StatusBadge status={status} /></td>;
    $[13] = status;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== startTimestamp) {
    t7 = new Date(startTimestamp).toLocaleString("en-us", {
      month: "numeric",
      day: "numeric",
      year: "2-digit",
      hour: "numeric",
      minute: "numeric"
    });
    $[15] = startTimestamp;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <td><div className="text-body-2 text-primary truncate">{t7}</div></td>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t3 || $[21] !== t5 || $[22] !== t6 || $[23] !== t8) {
    t9 = <>{t2}{t3}{t5}{t6}{t8}</>;
    $[19] = t2;
    $[20] = t3;
    $[21] = t5;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export default Row;